export const isValidHexColorCode = (str: string): boolean =>
  /^#[0-9a-fA-F]{6}$/.test(str);
